import React, { useEffect, useState } from 'react'
import type { PageProps } from 'gatsby'

import "./style.scss"
import Navbar from "../../components/Navbar"
import Seo from "../../components/Seo"
import type { TemplateProps } from "../../dtos/Template"

const images = [
  "https://media.graphcms.com/9ybk4xGFQFS9juSagcZE",
  "https://media.graphcms.com/CrMIGp6cT7qu3MFbkLW1",
  "https://media.graphcms.com/E23QoU5cR3Ox4RWzjDUa",
  "https://media.graphcms.com/aqlj4TB8ROSfd35XXBN0",
  "https://media.graphcms.com/8NCBOvjSBmoYtgA7l15z",
  "https://media.graphcms.com/bamgwDlQV2T2mvtolMIA",
  "https://media.graphcms.com/cLCVq3dSMquqCAm4f47Q",
  "https://media.graphcms.com/E5iOFEQOQUiLlBzfJnXc",
]

type IndexProps = TemplateProps & {
}

function Index( { pageContext }: PageProps) {

  const { sections, langs } = pageContext as IndexProps
  const { content } = sections[0]
  const [ activeBg, setActiveBg ] = useState(0)

  useEffect(() => {
    const timeOut = setTimeout(() => {
      const newActiveBg = (activeBg < images.length -1) ? activeBg + 1 : 0
      setActiveBg(newActiveBg)
    }, 6000)

    return () => { clearTimeout(timeOut) }
  } ,[activeBg])
  

  return (
    <>
      <Seo title={`${sections[0].display}`} />
      <div className="nav">
        <Navbar langs={langs}  sections={sections} />
      </div>
      <section id='Home'>
        <article>
          <div className="images">
            {images.map((image, index) => (
              <img
                className={index===activeBg?"active": ""}
                key={image} src={image} alt='bg' /> ))}
          </div>
          <div className="content">
            <div className="photoWrapper">
              <img src="https://media.graphcms.com/erq5SnTuaZqYIM4UYuEw" alt="evesan" />
            </div>
            <div className="textWrapper">
              {content.map((c, i) => (<div key={`content-${i}`} dangerouslySetInnerHTML={{ __html: c.html }} />)) }
            </div>
          </div>
        </article>
      </section>
    </>
  )
}

export default Index
